import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { INDEX_TYPE_OPTIONS } from '@/pages/instruments/new-instrument/constants/index-types'

export interface IndexTypeFormFieldProps {}

export const IndexTypeFormField: React.FC<IndexTypeFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ index_type: string }>()

  return (
    <FormField
      name="index_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Index Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select an index type...'}
              value={value}
              setValue={(value) => setValue('index_type', value, { shouldValidate: true })}
              options={INDEX_TYPE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
